import { useCanSeeEntityLinks } from 'v2/hooks';
import { useGetActivities } from 'v2/hooks/useGetActivities';
import { TableName, EActivityType } from 'v2/models';

type UseLinkCreatedInfiniteActivitiesProps = {
  searchID: number;
};

export function useLinkCreatedInfiniteActivities({
  searchID,
}: UseLinkCreatedInfiniteActivitiesProps) {
  const hasPermissionsToSeeEntityLinks = useCanSeeEntityLinks();

  return useGetActivities({
    enabled: hasPermissionsToSeeEntityLinks,
    relatedTable: TableName.Searches,
    relatedObjectId: searchID,
    filterSelectedOption: EActivityType.link_created,
  });
}
